import { useRef, useState } from 'react'
import { FormStore, FormConfig, FormApi, Formy } from '@formy/core'

export function useForm<T = any>(config: FormConfig<T>): FormApi {
  const [, forceUpdate] = useState({})
  const { current } = useRef(new FormStore(config, forceUpdate))
  if (config.name) {
    Formy.forms[config.name] = current
  }
  return current.getFormApi()
}
